import Isotope from "isotope-layout";
import gsap from "gsap";

let itemsToShowNb = 6;
let itemsForSeeMore = "*";

export default class mobilizersFilters {



    constructor() {
        const that = this;
        this.containers = document.querySelectorAll('.cp-three-news-portrait-filtered');
        if (this.containers.length === 0) return;

        const cp = document.querySelectorAll('.cp-three-news-portrait-filtered');
        cp.forEach((c) => {
            this.initIso(c);
        });

        window.addEventListener("click", function(event) {
            if(!event.target.classList.contains('js-tree-collapser') && !event.target.classList.contains('filter-btn')  ){
               that.hideCollapser();
            }



        });
    }


    initIso(c){
        const that = this;
        const isoC = c.querySelector('.iso-c');

        let iso = new Isotope( isoC, {
            // options
            transitionDuration: 0,
            itemSelector: '.news-container-item',
            layoutMode: 'fitRows',
        });

        this.initFilters(c, iso);
        this.reinitFilters(c,iso);
        this.nextPage(c, iso, '*');
        const arrayFilters = [];

        this.availableFormats(c);
    }

    initFilters(c,iso){
        const that = this;
        const btnFilters = c.querySelectorAll('.filter-btn ');
        btnFilters.forEach( (filter) => {

            filter.addEventListener('click', () => {

                this.switchClasses(c,filter);
                const arrayFilters = this.createFiltersArray(c,filter);

                const allItems = c.querySelectorAll('.news-container-item');
                gsap.to(allItems,{alpha:0, onComplete:function(){
                        that.showItems(c,iso,arrayFilters,allItems)
                    }
                })
            });

        });

    }


    showItems(c,iso,arrayFilters,allItems){
        var filtersValues = arrayFilters.length ? arrayFilters.join(', ') : '*';
        if(arrayFilters.length){
            c.querySelector('.reinitFilters').classList.add('active')
        }else{
            c.querySelector('.reinitFilters').classList.remove('active')
        }
        var arrange = iso.arrange({ filter: filtersValues });

        const itemsToShow = iso.filteredItems;
        itemsToShow.forEach((item, index) => {
            if (index < itemsToShowNb){
                item.element.style.display = "block";
            }else{
                item.element.style.display = "none";
            }
        });

        iso.layout();

        gsap.to(allItems,{alpha:1})
            /*iso.on('layoutComplete', function(){
                console.log('test')
            })*/

        this.displayShowMore(itemsToShow);
    }

    // SWITCH CLASSES FOR FILTERS BTNS
    switchClasses(c,filter){
        filter.classList.toggle('active-filter');
    }

    // CREATE ARRAY WITH ACTIVE FILTERS AND FORMATS
    createFiltersArray(c,filter){
        let that = this;
        const currentFilters = c.querySelectorAll('.filter-item-li.active-filter');
        let currentFormats = [];
        let currentFormatsSelected = c.querySelectorAll('.format-item-li.active-filter');

        // DEFINE FORMATS SELECTED
        if(currentFormatsSelected.length > 0){
            currentFormatsSelected.forEach((item) => {
                currentFormats.push(item.dataset.filter);
            });
        }

        let arrayFilters = [];
        let arrayFiltersReturn = [];

        // DEFINE FILTERS SELECTED
        currentFilters.forEach( (currentFilterItem) => {
            arrayFilters.push(currentFilterItem.dataset.filter);
        });

        // DEFINE LIST OF ISO FILTERS
        if(arrayFilters.length ){
            arrayFilters.forEach((filter, i) => {
                if(currentFormats.length > 0){
                    currentFormats.forEach((format) => {
                        arrayFiltersReturn.push(filter + '.' + format);
                    })
                }else{
                    arrayFiltersReturn.push(filter);
                }
            })
        }else{
            if(currentFormats.length > 0){
                currentFormats.forEach((format, i) => {
                    arrayFiltersReturn[i] = '.'+format;
                })
            }else{
                arrayFiltersReturn[0] = '*';
            }
        }


        if(filter.dataset.type != 'format'){
            this.updateFormats(c, arrayFilters);
        }

        return arrayFiltersReturn;
    }

    updateFormats(c,arrayFilters){
        const formats = c.querySelectorAll('.format-item-li');

        if(arrayFilters.length == 0){
            this.availableFormats(c);
        }else{
            let arrayRelatedFormats = [];
            arrayFilters.forEach( (filter) => {
                const relatedArticles = c.querySelectorAll('.news-container-item'+filter+'');
                relatedArticles.forEach((article) => {
                    const format = article.dataset.format;
                    if(!arrayRelatedFormats.includes(format)){
                        arrayRelatedFormats.push(format)
                    }
                });
            });

            formats.forEach((format) => {
                if(arrayRelatedFormats.includes(format.dataset.filter)){
                    format.style.display = 'flex';
                }else{
                    format.style.display = 'none';
                }
            })
        }
    }

    availableFormats(c){
        let arrayFormats = [];
        const relatedArticles = c.querySelectorAll('.news-container-item');
        relatedArticles.forEach((article) => {
            const format = article.dataset.format;
            if(!arrayFormats.includes(format)){
                arrayFormats.push(format)
            }
        });

        const formats = c.querySelectorAll('.format-item-li');
        formats.forEach((format) => {
            if(arrayFormats.includes(format.dataset.filter)){
                format.style.display = 'flex';
            }else{
                format.style.display = 'none';
            }
        })
    }

    reinitFilters(c, iso){
        const btnReInit = c.querySelector('.reinitFilters');
        const that = this;

        btnReInit.addEventListener('click', () => {
            btnReInit.classList.remove('active')
            const filters = c.querySelectorAll('.filter-btn');
            filters.forEach((filter) => {
                filter.classList.remove('active-filter');
            });

            const allItems = c.querySelectorAll('.news-container-item');
            const arrayFilters = [];
            gsap.to(allItems,{alpha:0, onComplete:function() {
                    that.showItems(c, iso, arrayFilters, allItems);
            }});

           this.hideCollapser();

            this.availableFormats(c);
        });



    }

    displayShowMore(itemsToShow){

        if(itemsToShowNb >= itemsToShow.length){
            document.querySelector('#mobilizersFilterNext').style.display = 'none'
        }else{
            document.querySelector('#mobilizersFilterNext').style.display = 'block'

        }
    }

    nextPage(c, iso,filtersValues) {
        const that = this;
        const nextBtn = c.querySelector('#mobilizersFilterNext');

        /*iso.arrange({ filter: filtersValues });


        const itemsToShow = iso.filteredItems;
        itemsToShow.forEach((item, index) => {
            if (index < itemsToShowNb){
                item.element.style.display = "block";

            }else{
                item.element.style.display = "none";
            }
        });*/

        nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const allFiltersItems = iso.filteredItems;
            const newFiltersItems = allFiltersItems.slice(itemsToShowNb, itemsToShowNb+6)
            itemsToShowNb = itemsToShowNb+6;

          newFiltersItems.forEach((item, index) => {
                item.element.style.display = "block";
                gsap.to(item.element,{alpha:1})
            });
            iso.layout();
            that.displayShowMore(allFiltersItems);

        });
    }

    hideCollapser(){
        // CLOSE SELECTOR
        if(document.querySelector('.js-tree-collapser-ul-active')){
            const OpenSelector = document.querySelector('.js-tree-collapser-ul-active');
            document.querySelector('.js-tree-collapser-active').classList.remove('js-tree-collapser-active');
            OpenSelector.classList.remove('js-tree-collapser-ul-active');
            OpenSelector.style.height = 0;
        }
    }


}
